import { render, staticRenderFns } from "./share-icon.vue?vue&type=template&id=7aba9394&"
import script from "./share-icon.vue?vue&type=script&lang=js&"
export * from "./share-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports